import initModel from "../Model";
import { rapportDetailUrl, detailHttpSuccessMsg, httpErrorMsg } from "../Update";

export const MSGS_UPLOAD = {
    REMOVE_OLD_FILE: 'REMOVE_OLD_FILE',
    UPLOAD_FILE: 'UPLOAD_FILE',
    UPLOAD_EMAIL_INPUT: 'UPLOAD_EMAIL_INPUT',
    UPLOAD_PIN: 'UPLOAD_PIN',
    UPLOAD_TITLE: 'UPLOAD_TITLE',
    UPLOAD_SHORT_TITLE: 'UPLOAD_SHORT_TITLE',
    UPLOAD_SUB_TITLE: 'UPLOAD_SUB_TITLE',
    UPLOAD_AUTHOR: 'UPLOAD_AUTHOR',
    UPLOAD_PUBLISH_DATE: 'UPLOAD_PUBLISH_DATE',
    UPLOAD_NO_OF_PAGES: 'UPLOAD_NO_OF_PAGES',
    UPLOAD_ISBN: 'UPLOAD_ISBN',
    UPLOAD_KEYWORD: 'UPLOAD_KEYWORD', UPLOAD_METHOD: 'UPLOAD_METHOD', UPLOAD_CENTER: 'UPLOAD_CENTER',
    UPLOAD_LAWS: 'UPLOAD_LAWS', UPLOAD_PURPOSE: 'UPLOAD_PURPOSE', UPLOAD_MUNICIPALITY: 'UPLOAD_MUNICIPALITY', SEARCH_MUNICIPALITY: 'SEARCH_MUNICIPALITY',
    UPLOAD_FORM_SUBMIT: 'UPLOAD_FORM_SUBMIT',
    EDIT_FORM_SUBMIT: 'EDIT_FORM_SUBMIT',
    REPORT_UPLOADED_HTTP_SUCCESS: 'REPORT_UPLOADED_HTTP_SUCCESS',
    HTTP_UPLOAD_FORM_ERROR: 'HTTP_UPLOAD_FORM_ERROR',
    CLEAR_UPLOAD_STATUS_BANNER: 'CLEAR_UPLOAD_STATUS_BANNER',

    HIGHLIGHT_DRAG: 'HIGHLIGHT_DRAG',
    DRAG_DROP: 'DRAG_DROP',
    REMOVE_FILES: 'REMOVE_FILES',
    ADD_GEOREF: 'ADD_GEOREF',
    STR_GEOREF: 'STR_GEOREF',
    CLEAR_WKT: 'CLEAR_WKT',
    GEOREF_DRAW_TYPE:'GEOREF_DRAW_TYPE',

    ADD_DGU: 'ADD_DGU',
    SEARCH_DGU_INFO: 'SEARCH_DGU_INFO',
    DGU_NR: 'DGU_NR',
    SELECT_DGU: 'SELECT_DGU',
    CLEAR_DGU: 'CLEAR_DGU',
    SEARCH_DGU_HTTP_SUCCESS: 'SEARCH_DGU_HTTP_SUCCESS',
    HTTP_SEARCH_DGU_ERROR: 'HTTP_SEARCH_DGU_ERROR',

    GEO_FYS_TEXT: 'GEO_FYS_TEXT',
    SEARCH_GEO_FYS_INFO: 'SEARCH_GEO_FYS_INFO',
    SEARCH_GEO_FYS_HTTP_SUCCESS: 'SEARCH_GEO_FYS_HTTP_SUCCESS',
    SELECT_GEO_FYS: 'SELECT_GEO_FYS',
    ADD_GEO_FYS: 'ADD_GEO_FYS',
    REMOVE_GEO_FYS_PROJECT: 'REMOVE_GEO_FYS_PROJECT',


    UPLOAD_TAB: 'UPLOAD_TAB',
    MODEL_LINK: 'MODEL_LINK',
    ADD_MODEL_LINK: 'ADD_MODEL_LINK',
    REMOVE_MODEL_LINK: 'REMOVE_MODEL_LINK',
    SELECTED_AREA_TAB: 'SELECTED_AREA_TAB'
};

export function geoRefDrawTypeMsg(type) {
    return {
        type: MSGS_UPLOAD.GEOREF_DRAW_TYPE,
        drawType: type,
    };
}

export function tabSelectAreaMsg(selectArea) {
    return {
        type: MSGS_UPLOAD.SELECTED_AREA_TAB,
        selectArea,
    };
}
export function tabMsg(tab) {
    return {
        type: MSGS_UPLOAD.UPLOAD_TAB,
        tab,
    };
}
export const removeFilesMsg = {
    type: MSGS_UPLOAD.REMOVE_FILES,
}
export function removeOldFileMsg(fileIndex) {
    return {
        type: MSGS_UPLOAD.REMOVE_OLD_FILE,
        index: fileIndex
    };
}
export function georefStringUploadMsg(wkt) {
    return {
        type: MSGS_UPLOAD.STR_GEOREF,
        wkt,
    };
}
export const georefUploadMsg = {
    type: MSGS_UPLOAD.ADD_GEOREF
}
/* --- Geo fysisk --- */
const searchGeoFysHttpSuccessMsg = ((response) => ({
    type: MSGS_UPLOAD.SEARCH_GEO_FYS_HTTP_SUCCESS,
    response,
}));
export const getGeoFysTextSearchBtnMsg = {
    type: MSGS_UPLOAD.SEARCH_GEO_FYS_INFO,
};
export const addGeoFysBtnMsg = {
    type: MSGS_UPLOAD.ADD_GEO_FYS
}
export function geoFysTextMsg(geoFysText) {
    return {
        type: MSGS_UPLOAD.GEO_FYS_TEXT,
        geoFysText,
    };
}
export function selectGeoFysMsg(selectedGeoFysProject) {
    return {
        type: MSGS_UPLOAD.SELECT_GEO_FYS,
        selectedGeoFysProject,
    };
}
export function removeAddedGeoFysProject(geoFysProjectIndex) {
    return {
        type: MSGS_UPLOAD.REMOVE_GEO_FYS_PROJECT,
        index: geoFysProjectIndex
    }
}
/* --- Modeller --- */
export const addModelLinkBtnMsg = {
    type: MSGS_UPLOAD.ADD_MODEL_LINK
}
export function modelLinkMsg(modelLink) {
    return {
        type: MSGS_UPLOAD.MODEL_LINK,
        modelLink,
    };
}
export function removeAddedModelMsg(modelLinkIndex) {
    return {
        type: MSGS_UPLOAD.REMOVE_MODEL_LINK,
        index: modelLinkIndex
    }
}

function httpSearchErrorMsg(error) {
    return {
        type: MSGS_UPLOAD.HTTP_SEARCH_DGU_ERROR,
        error,
    };
}
/* --- DGU --- */
export function selectDguMsg(selectedDgu) {
    return {
        type: MSGS_UPLOAD.SELECT_DGU,
        selectedDgu,
    };
}
export const addDguBtnMsg = {
    type: MSGS_UPLOAD.ADD_DGU
}
export const getDguInfoMsg = {
    type: MSGS_UPLOAD.SEARCH_DGU_INFO
}
export function removeDguMsg(dguIndex) {
    return {
        type: MSGS_UPLOAD.CLEAR_DGU,
        index: dguIndex
    };
}
export function dguUploadMsg(dguNr) {
    return {
        type: MSGS_UPLOAD.DGU_NR,
        dguNr,
    };
}
/* ---------------------------------------- */

export function uploadFilUploadMsg(fileName) {
    return {
        type: MSGS_UPLOAD.UPLOAD_FILE,
        fileName,
    };
}
export function dropDragMsg(files) {
    return {
        type: MSGS_UPLOAD.DRAG_DROP,
        files,
    };
}
export function emailUploadMsg(email) {
    return {
        type: MSGS_UPLOAD.UPLOAD_EMAIL_INPUT,
        email,
    };
}
export function pinUploadMsg(pin) {
    return {
        type: MSGS_UPLOAD.UPLOAD_PIN,
        pin,
    };
}
export function titleUploadMsg(title) {
    return {
        type: MSGS_UPLOAD.UPLOAD_TITLE,
        title,
    };
}
export function kortTitelUploadMsg(shortTitle) {
    return {
        type: MSGS_UPLOAD.UPLOAD_SHORT_TITLE,
        shortTitle,
    };
}
export function undertitelUploadMsg(subTitle) {
    return {
        type: MSGS_UPLOAD.UPLOAD_SUB_TITLE,
        subTitle,
    };
}
export function forfatterUploadMsg(author) {
    return {
        type: MSGS_UPLOAD.UPLOAD_AUTHOR,
        author,
    };
}
export function udgivelsesDatoUploadMsg(publishDate) {
    return {
        type: MSGS_UPLOAD.UPLOAD_PUBLISH_DATE,
        publishDate,
    };
}
export function siderUploadMsg(pages) {
    return {
        type: MSGS_UPLOAD.UPLOAD_NO_OF_PAGES,
        pages,
    };
}
export function isbnUploadMsg(isbn) {
    return {
        type: MSGS_UPLOAD.UPLOAD_ISBN,
        isbn,
    };
}

export function keywordSelectUploadMsg(selectedKeyword) {
    return {
        type: MSGS_UPLOAD.UPLOAD_KEYWORD,
        selectedKeyword,
    };
}
export function methodSelectUploadMsg(selectedMethod) {
    return {
        type: MSGS_UPLOAD.UPLOAD_METHOD,
        selectedMethod,
    };
}
export function centerSelectUploadMsg(selectedCenter) {
    return {
        type: MSGS_UPLOAD.UPLOAD_CENTER,
        selectedCenter,
    };
}
export function lawsSelectUploadMsg(selectedLaws) {
    return {
        type: MSGS_UPLOAD.UPLOAD_LAWS,
        selectedLaws,
    };
}
export function purposeSelectUploadMsg(selectedPurpose) {
    return {
        type: MSGS_UPLOAD.UPLOAD_PURPOSE,
        selectedPurpose,
    };
}
export function searchMunicipalityInputMsg(searchedMunicipality) {
    return {
      type: MSGS_UPLOAD.SEARCH_MUNICIPALITY,
      searchedMunicipality,
    };
}
export function municipalitySelectUploadMsg(selectedMunicipality) {
    return {
        type: MSGS_UPLOAD.UPLOAD_MUNICIPALITY,
        selectedMunicipality,
    };
}

export function highlightDragMsg(flag) {
    return {
        type: MSGS_UPLOAD.HIGHLIGHT_DRAG,
        flag
    };
}
function httpUploadErrorMsg(error) {
    return {
        type: MSGS_UPLOAD.HTTP_UPLOAD_FORM_ERROR,
        error,
    };
}

export function removeWktMsg(wktIndex) {
    return {
        type: MSGS_UPLOAD.CLEAR_WKT,
        index: wktIndex
    }
}

export const clearUploadStatusBannerMsg = {
    type: MSGS_UPLOAD.CLEAR_UPLOAD_STATUS_BANNER,
}
export const uploadMsg = {
    type: MSGS_UPLOAD.UPLOAD_FORM_SUBMIT,
};
export const editMsg = {
    type: MSGS_UPLOAD.EDIT_FORM_SUBMIT,
};
const reportUploadedHttpSuccessMsg = ((response) => ({
    type: MSGS_UPLOAD.REPORT_UPLOADED_HTTP_SUCCESS,
    response,
}));
const searchDguHttpSuccessMsg = ((response) => ({
   type: MSGS_UPLOAD.SEARCH_DGU_HTTP_SUCCESS,
   response,
}));

/* --------- UPLOAD ---------*/
export function uploadUpdate(msg, model) {
    switch (msg.type) {

        case MSGS_UPLOAD.UPLOAD_EMAIL_INPUT: {
            const { email } = msg;
            return { ...model,
                upload: { ...model.upload, email: email },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_PIN: {
            const { pin } = msg;
            return { ...model,
                upload: { ...model.upload, pin: pin },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_TITLE: {
            const { title } = msg;
            return { ...model,
                upload: { ...model.upload, title: title },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_SHORT_TITLE: {
            const { shortTitle } = msg;
            return { ...model,
                upload: { ...model.upload, shortTitle: shortTitle },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_SUB_TITLE: {
            const { subTitle } = msg;
            return { ...model,
                upload: { ...model.upload, subTitle: subTitle },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_AUTHOR: {
            const { author } = msg;
            return { ...model,
                upload: { ...model.upload, author: author },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_PUBLISH_DATE: {
            const { publishDate } = msg;
            return { ...model,
                upload: { ...model.upload, publishDate: publishDate },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_NO_OF_PAGES: {
            const { pages } = msg;
            return { ...model,
                upload: { ...model.upload, pages: pages },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_ISBN: {
            const { isbn } = msg;
            return { ...model,
                upload: { ...model.upload, isbn: isbn },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_KEYWORD: {
            const { selectedKeyword } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedKeyword: selectedKeyword },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_METHOD: {
            const { selectedMethod } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedMethod: selectedMethod },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_CENTER: {
            const { selectedCenter } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedCenter: selectedCenter },
                success: '',
                error: ''
            };
        }

        /*------ Lovgrundlag - Formål - Kommune ------*/
        case MSGS_UPLOAD.UPLOAD_LAWS: {
            const { selectedLaws } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedLaws: selectedLaws },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_PURPOSE: {
            const { selectedPurpose } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedPurpose: selectedPurpose },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.SEARCH_MUNICIPALITY: {
            const { searchedMunicipality } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedMunicipality: '', searchedMunicipality: searchedMunicipality },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_MUNICIPALITY: {
            const { selectedMunicipality } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedMunicipality: selectedMunicipality, searchedMunicipality: '' },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.STR_GEOREF: {
            const { wkt } = msg;
            return {
                ...model,
                upload: { ...model.upload, addingWkt: wkt },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.ADD_GEOREF: {
            const wktArr = [];

            const le = model.upload.wkt.length;
            if (le > 0)
                model.upload.wkt[le - 1] = model.upload.wkt[le - 1] + '+';

            wktArr.push(...model.upload.wkt);
            wktArr.push(model.upload.addingWkt);
            return {
                ...model,
                upload: { ...model.upload, wkt: wktArr, addingWkt: '' },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.GEOREF_DRAW_TYPE: {
            const { drawType } = msg;
            return { ...model,
                upload: { ...model.upload, drawType: drawType },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.UPLOAD_FILE: {
            const { fileName } = msg;
            return { ...model,
                upload: { ...model.upload, fileName: fileName },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.HIGHLIGHT_DRAG: {
            const { flag } = msg;
            if (flag === 'on')
                return { ...model, upload: { ...model.upload, dragHighlight: true } };

            return { ...model, upload: { ...model.upload, dragHighlight: false } };
        }
        case MSGS_UPLOAD.DRAG_DROP: {
            const { files } = msg;
            const filesArr = [...files];
            const newFileNames = filesArr.map(f => f.name);
            const fileNames = newFileNames.push(...model.upload.fileNames);

            filesArr.push(...model.upload.filesArr);

            return { ...model,
                upload: { ...model.upload, fileNames: newFileNames, files: files, filesArr: filesArr }
            };
        }

        case MSGS_UPLOAD.REMOVE_OLD_FILE: {
            const { index } = msg;
            let current = [ ...model.upload.oldFiles ];
            let currentFull = [ ...model.upload.oldFilesIds ];

            if (current.length > index) { // only splice array when item is found
                current.splice(index, 1); // 2nd parameter means remove one item only
                currentFull.splice(index, 1); // 2nd parameter means remove one item only
            }
            return { ...model, upload: { ...model.upload, oldFiles: current, oldFilesIds: currentFull } };
        }

        /* --------------------- DGUNR --------------------------*/
        case MSGS_UPLOAD.DGU_NR: {
            const { dguNr } = msg;
            return { ...model,
                upload: { ...model.upload, dguNr: dguNr },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.SELECT_DGU: {
            const { selectedDgu } = msg;
            return { ...model,
                upload: { ...model.upload, selectedDgu: selectedDgu },
                success: '',
                error: ''
            };
        }
        case MSGS_UPLOAD.SEARCH_DGU_INFO: {
            if (!model.upload.dguNr) return model;

            const val = model.upload.dguNr.replace('.', '.*');
            return {
                ...model,
                request: {
                    url: 'https://data.geus.dk/gw-jupiter/borehole?limit=160&offset=0&boreholeno=like.*' + val  + '*'
                },
                upload: { ...model.upload, selectedDgu: '', dguList: [] },
                call: true,
                successMsg: searchDguHttpSuccessMsg,
                errorMsg: httpSearchErrorMsg,
            };
        }

        case MSGS_UPLOAD.CLEAR_DGU: {
            const { index } = msg;
            let current = [ ...model.upload.addedDgu ];
            let currentFull = [ ...model.upload.addedDguFull ];

            if (current.length > index) { // only splice array when item is found
                current.splice(index, 1); // 2nd parameter means remove one item only
                currentFull.splice(index, 1); // 2nd parameter means remove one item only
            }
            return { ...model, upload: { ...model.upload, addedDgu: current, addedDguFull: currentFull, dguNrError: '' } };
        }
        case MSGS_UPLOAD.SEARCH_DGU_HTTP_SUCCESS: {
            const { response } = msg;

            if (!response.data || response.data.length === 0) {
                return {
                    ...model,
                    request: { },
                    call: false,
                    post: false,
                    upload: { ...model.upload, dguNrError: ('Intet fundet.') },
                    successMsg: '',
                    errorMsg: '',
                };
            }

            const sortedResult = response.data.sort((a,b) => {
                if (a.boreholeno.replace(/\s/g, '').length === b.boreholeno.replace(/\s/g, '').length)
                    return a.boreholeno.localeCompare(b.boreholeno);  // otherwise standard sort

                return a.boreholeno.replace(/\s/g, '').length - b.boreholeno.replace(/\s/g, '').length; // shortest dgu no first
            });

            const warnOverLimit = sortedResult.length > 150;
            return {
                ...model,
                request: { },
                call: false,
                post: false,
                upload: { ...model.upload, dguList: sortedResult, warnOverLimit: warnOverLimit }
            };
        }
        case MSGS_UPLOAD.HTTP_SEARCH_DGU_ERROR: {
            const { error } = msg;
            return {
                ...model,
                request: { },
                call: false,
                post: false,
                upload: { ...model.upload, dguList: [], error: error },
                successMsg: '',
                errorMsg: '',
            };
        }
        case MSGS_UPLOAD.ADD_DGU: {
            if (!model.upload.selectedDgu) return model;

            const selectedDguFull = model.upload.dguList.find(item => item.boreholeid === parseInt(model.upload.selectedDgu));
            if (model.upload.addedDguFull.includes(selectedDguFull.boreholeid)) {
                return {
                    ...model,
                    upload: { ...model.upload, dguNrError: 'Boringen er allerede tilføjet.' }
                }
            }

            const addedFull = [ ...model.upload.addedDguFull ];
            addedFull.push( selectedDguFull.boreholeid );

            const added = [ ...model.upload.addedDgu ];
            added.push( selectedDguFull.boreholeno + ' (' + selectedDguFull.location + ')' );
            return {
                ...model,
                upload: { ...model.upload, addedDgu: added, addedDguFull: addedFull, dguNrError: '' } // selectedDgu: '',
            }
        }
        /* --------------------------------------------------*/
        case MSGS_UPLOAD.CLEAR_WKT: {
            const { index } = msg;
            let current = [ ...model.upload.wkt ];
            if (current.length > index) {
                current.splice(index, 1);
            }

            return { ...model, upload: { ...model.upload, wkt: current } };
        }
        case MSGS_UPLOAD.UPLOAD_FORM_SUBMIT: {
            if (!model.showSure && model.upload.fileNames.length === 0)
                return { ...model, showSure: true }

            return {
                ...model,
                post: true,
                request: {
                   url: `/formular-api/api/form`,
                },
                showSure: false,
                upload: { ...model.upload, success: '', error: '', errorModal: false },
                successMsg: reportUploadedHttpSuccessMsg,
                errorMsg: httpUploadErrorMsg,
            };
        }
        case MSGS_UPLOAD.EDIT_FORM_SUBMIT: {
            if (!model.showSure && model.upload.fileNames.length === 0 && model.upload.oldFiles.length === 0)
                return { ...model, showSure: true }

            return {
                ...model,
                post: true,
                request: {
                   url: `/grundvandsrapport/api/update`,
                },
                showSure: false,
                upload: { ...model.upload, success: '', error: '', errorModal: false },
                successMsg: reportUploadedHttpSuccessMsg,
                errorMsg: httpUploadErrorMsg,
            };
        }
        case MSGS_UPLOAD.REPORT_UPLOADED_HTTP_SUCCESS: {
            const { response } = msg;
            return {
                ...model,
                request: { },
                call: false,
                post: false,
                upload: { ...initModel.upload, email: model.upload.email, pin: model.upload.pin, success: 'SUCCESS' },
                rapportid: response.data,
                // , error: '', errorModal: false, files: {}, fileNames: [], addedDgu: [], wkt: [], dguList: []
                error: '',
                successMsg: '',
                errorMsg: '',
            };
        }
        case MSGS_UPLOAD.HTTP_UPLOAD_FORM_ERROR: {
            const { error } = msg;
            if (error.response && error.response.status === 401) {
                return { ...model, error: '' /*response.data*/ , state: 'upload', success: '', request: { }, call: false, post: false,
                            upload: {...model.upload, success: '', error: 'Fejl: Email er ikke godkendt til upload eller pinkode er udløbet.', errorModal: true },
                            successMsg: '', errorMsg: '', };
            }
            const keepState = model.state === 'edit' ? 'edit' : 'upload';
            return { ...model, error: '' /*response.data*/ , state: keepState, success: '', request: { }, call: false, post: false,
                upload: {...model.upload, success: '', error: error.message, errorModal: true,
                 }, successMsg: '', errorMsg: '' };
        }
        case MSGS_UPLOAD.CLEAR_UPLOAD_STATUS_BANNER: {
            if (model.upload.success === 'SUCCESS') {
                // return { ...model, state: 'detail', selectedRapportId: model.rapportId , upload: { ...initModel.upload } };
                return { ...model, state: 'detail', detail: { ...model.detail, selectedRapportId: model.rapportid, loadReportId: '', loadLinks: true },
                    request: {
                        url: rapportDetailUrl(model.rapportid)
                    },
                    call: true,
                    successMsg: detailHttpSuccessMsg,
                    errorMsg: httpErrorMsg,
                };
            }
            return { ...model, upload: {...model.upload, success: '', errorModal: false } };
        }
        case MSGS_UPLOAD.REMOVE_FILES: {
            return { ...model, upload: { ...model.upload, files: {} , filesArr: [], fileNames: [] } };
        }

        /* --- GEO FYS --- */
        case MSGS_UPLOAD.GEO_FYS_TEXT: {
             const { geoFysText } = msg;
             return { ...model,
                 upload: { ...model.upload, geoFysText: geoFysText, geoFysTextSearchError: '' },
                 success: '',
                 error: ''
             };
        }
        case MSGS_UPLOAD.SEARCH_GEO_FYS_INFO: {
            return {
                ...model,
                request: {
                    url: 'https://data.geus.dk/gw-gerda/www_search_page?limit=50&offset=0&freetext_search=like.*' + model.upload.geoFysText + '*&select=project',
                },
                upload: { ...model.upload, selectedGeoFysProject: '', geoFysList: [] },
                call: true,
                successMsg: searchGeoFysHttpSuccessMsg,
                errorMsg: httpSearchErrorMsg,
            };
        }
        case MSGS_UPLOAD.SEARCH_GEO_FYS_HTTP_SUCCESS: {
            const { response } = msg;

            if (!response.data || response.data.length === 0) {
                return {
                    ...model,
                    request: { },
                    call: false,
                    post: false,
                    upload: { ...model.upload, geoFysTextSearchError: ('Intet fundet.') },
                    successMsg: '',
                    errorMsg: '',
                };
            }

            return {
                ...model,
                request: { },
                call: false,
                post: false,
                upload: { ...model.upload, geoFysList: response.data }
            };
        }
        case MSGS_UPLOAD.SELECT_GEO_FYS: {
            const { selectedGeoFysProject } = msg;
            return {
                ...model,
                upload: { ...model.upload, selectedGeoFysProject: selectedGeoFysProject }
            }
        }
        case MSGS_UPLOAD.ADD_GEO_FYS: {
            if (!model.upload.selectedGeoFysProject) return model;

            if (model.upload.addedGeoFysProject.includes(model.upload.selectedGeoFysProject)) {
                return {
                    ...model,
                    upload: { ...model.upload, geoFysTextSearchError: 'Projektet er allerede tilføjet.' }
                }
            }

            const added = [ ...model.upload.addedGeoFysProject ];
            added.push( model.upload.selectedGeoFysProject );
            return {
                ...model,
                upload: { ...model.upload, addedGeoFysProject: added, selectedGeoFysProject: '', geoFysTextSearchError: '' }
            }
        }
        case MSGS_UPLOAD.REMOVE_GEO_FYS_PROJECT: {
            const { index } = msg;
            let current = [ ...model.upload.addedGeoFysProject ];

            if (current.length > index) {
              current.splice(index, 1);
            }

            return { ...model,
                upload: { ...model.upload, addedGeoFysProject: current }
            };
        }

        /* -------- MODEL LINKS ------- */
        case MSGS_UPLOAD.MODEL_LINK: {
             const { modelLink } = msg;
             return { ...model,
                 upload: { ...model.upload, modelLink: modelLink, modelLinkError: '' },
                 success: '',
                 error: ''
             };
        }
        case MSGS_UPLOAD.ADD_MODEL_LINK: {
            if (!model.upload.modelLink) return model;

            if (model.upload.addedModelLink.includes(model.upload.modelLink)) {
                return {
                    ...model,
                    upload: { ...model.upload, modelLinkError: 'Modellen er allerede tilføjet.' } // MANGLER ERROR VISNING I VIEW
                }
            }
            const added = [ ...model.upload.addedModelLink ];
            added.push( model.upload.modelLink );
            return {
                ...model,
                upload: { ...model.upload, addedModelLink: added, modelLink: '', modelLinkError: '' }
            }
        }
        case MSGS_UPLOAD.REMOVE_MODEL_LINK: {
            const { index } = msg;
            let current = [ ...model.upload.addedModelLink ];

            if (current.length > index) {
              current.splice(index, 1);
            }

            return { ...model,
                upload: { ...model.upload, addedModelLink: current }
            };
        }

        /* ------------ TABS ---------- */
        case MSGS_UPLOAD.UPLOAD_TAB: {
            const { tab } = msg;
            return { ...model, upload: { ...model.upload, tab: tab }
            };
        }

        case MSGS_UPLOAD.SELECTED_AREA_TAB: {
            const { selectArea } = msg;
            return { ...model, upload: { ...model.upload, selectArea: selectArea } };
        }
    }
    return model;
}